/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const BusinessReasonCode = {
    NotSpecified: 'NotSpecified',
    PreparationForImbalanceSettlement: 'PreparationForImbalanceSettlement',
    Temporary: 'Temporary',
    FirstSettlement: 'FirstSettlement',
    SecondSettlement: 'SecondSettlement',
    ContinuousMeterReadingProfiled: 'ContinuousMeterReadingProfiled',
    RollbackChangeOfSupplier: 'RollbackChangeOfSupplier',
    LatestAvailableValue: 'LatestAvailableValue',
    ProfiledConsumption: 'ProfiledConsumption',
    IncorrectProcess: 'IncorrectProcess',
    CancelReading: 'CancelReading',
    ChangeOfSupplyToSupplierOfLastResort: 'ChangeOfSupplyToSupplierOfLastResort',
    CloseDownMeteringPoint: 'CloseDownMeteringPoint',
    ConnectMeteringpoint: 'ConnectMeteringpoint',
    MergeOfGrids: 'MergeOfGrids',
    UpdateMasterdataSettlement: 'UpdateMasterdataSettlement',
    UpdateChargeInformation: 'UpdateChargeInformation',
    MeterStand: 'MeterStand',
    ElectricalHeating: 'ElectricalHeating',
    MoveInOtherReason: 'MoveInOtherReason',
    ServiceRequest: 'ServiceRequest',
    NotUsedD23: 'NotUsedD23',
    NotUsedD24: 'NotUsedD24',
    MissingNonprofiledTimeSeries: 'MissingNonprofiledTimeSeries',
    MissingFlexTimeSeries: 'MissingFlexTimeSeries',
    MissingProfiledTimeSeries: 'MissingProfiledTimeSeries',
    ProposalContactInformation: 'ProposalContactInformation',
    SecondaryMoveIn: 'SecondaryMoveIn',
    SwitchWithShortNotice: 'SwitchWithShortNotice',
    TransferMeteringPoint: 'TransferMeteringPoint',
    CorrectionSettlement: 'CorrectionSettlement',
    IncorrectMove: 'IncorrectMove',
    EndSupplyDueToReallocate: 'EndSupplyDueToReallocate',
    ContinueSupplyDueToRejectedReallocate: 'ContinueSupplyDueToRejectedReallocate',
    ContinueSupplyOfCustomer: 'ContinueSupplyOfCustomer',
    CancelServiceRequest: 'CancelServiceRequest',
    EndOfSupplyWithShortNotice: 'EndOfSupplyWithShortNotice',
    ProductionObligation: 'ProductionObligation',
    RemovedParentRelationOnMeteringpoint: 'RemovedParentRelationOnMeteringpoint',
    NoDisconnectionOfMeteringpoint: 'NoDisconnectionOfMeteringpoint',
    PeriodicFlexMetering: 'PeriodicFlexMetering',
    HistoricalInformationAboutConsumption: 'HistoricalInformationAboutConsumption',
    ProcessCancelledByRequestingParty: 'ProcessCancelledByRequestingParty',
    ProcessCancelledByItx: 'ProcessCancelledByItx',
    Move: 'Move',
    NedMeteringPoint: 'NedMeteringPoint',
    ChangeOfBalanceSupplier: 'ChangeOfBalanceSupplier',
    Cancellation: 'Cancellation',
    UnrequestedChangeOfBalanceSupplier: 'UnrequestedChangeOfBalanceSupplier',
    DataAlignmentForMasterDataMeteringPoint: 'DataAlignmentForMasterDataMeteringPoint',
    EndOfSupply: 'EndOfSupply',
    Periodical: 'Periodical',
    HistoricalData: 'HistoricalData',
    UpdateMasterDataMeteringPoint: 'UpdateMasterDataMeteringPoint',
    UpdateMasterDataConsumer: 'UpdateMasterDataConsumer',
    MeterReadingOnDemand: 'MeterReadingOnDemand',
    ChangeOfBalanceResponsibleParty: 'ChangeOfBalanceResponsibleParty',
    CustomerMoveIn: 'CustomerMoveIn',
    ConsumerMoveOut: 'ConsumerMoveOut',
    PlacementOfMeter: 'PlacementOfMeter',
    ChangeOfMeteringMethod: 'ChangeOfMeteringMethod',
    ChangeOfConnectionStatus: 'ChangeOfConnectionStatus',
    ChangeOfEstimatedAnnualVolume: 'ChangeOfEstimatedAnnualVolume',
    UpdateMasterDataMeter: 'UpdateMasterDataMeter',
} as const;
export type BusinessReasonCode = typeof BusinessReasonCode[keyof typeof BusinessReasonCode];

